export default {
  MULTIPLE_CHOICE: {
    DEFAULT_OPTIONS: [''],
    OFFLINE_MESSAGE:
      '抱歉，我現在沒有連結到網路。因此我無法處理您的回答'
  }
}
